export const LOGIN = 'login';
export const REGISTRATION = 'registration';
export const FORGOT_PASSWORD = 'forgot-password';
